import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import "core-js/modules/es.function.name.js";
import React from "react";
import { Typography, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, RaiseColors } from "componentLibrary";
import { CustomRaiseTypography } from "componentLibrary/theme/RaiseTypography";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RadioGroupForm = function RadioGroupForm(_ref) {
  var name = _ref.name,
    label = _ref.label,
    options = _ref.options,
    value = _ref.value,
    fullWidth = _ref.fullWidth,
    showNoneOption = _ref.showNoneOption,
    onChange = _ref.onChange;
  return /*#__PURE__*/_jsxs(FormControl, {
    fullWidth: fullWidth,
    children: [label && /*#__PURE__*/_jsx(FormLabel, {
      children: label
    }), /*#__PURE__*/_jsxs(RadioGroup, {
      name: name,
      onChange: onChange,
      value: value !== null && value !== void 0 ? value : "",
      children: [showNoneOption && /*#__PURE__*/_jsx(FormControlLabel, {
        value: "",
        control: /*#__PURE__*/_jsx(Radio, {}),
        label: /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph_small",
          weight: "medium",
          color: RaiseColors.glacier2400,
          children: "None"
        })
      }), _mapInstanceProperty(options).call(options, function (option, index) {
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(FormControlLabel, {
            componentsProps: {
              typography: {
                style: _objectSpread({
                  width: fullWidth ? "100%" : undefined,
                  fontWeight: 500
                }, CustomRaiseTypography.paragraph_small)
              }
            },
            value: option.value,
            control: /*#__PURE__*/_jsx(Radio, {}),
            label: option.label
          }), option.content && option.content]
        }, index);
      })]
    })]
  });
};
export default RadioGroupForm;